import React, {useEffect, useState} from "react";
import {css, SerializedStyles} from "@emotion/react";

import {calculateRemSize, flexAbsoluteCenter, flexDirection, m, mb, minHeight, position} from "@pg-design/helpers-css";
import {Input} from "@pg-design/inputs-module";
import {Popover} from "@pg-design/notifications";
import {Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

import {CalculatorValueType} from "../../types/CalculatorValueType";
import {formatBigNumbers} from "../../utils/format_big_numbers";

interface IPopup {
    show: boolean;
    isMin: boolean;
}

const popupInitialState: IPopup = {
    show: false,
    isMin: true
};

interface IProps {
    value: number;
    label: string;
    min: number;
    max: number;
    wrapperStyle?: SerializedStyles | SerializedStyles[];
    valueType: CalculatorValueType;
    updateValue: (type: CalculatorValueType, value: number) => void;
    onInvalidValue: (value?: number) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onAfterBlur?: (value: number, min: number, max: number) => void;
    convertedPercentBase?: number;
    dataTestId?: string;
}

export const CalculatorBaseInput = (props: IProps) => {
    const {value, min, max, label, valueType, updateValue, wrapperStyle, onInvalidValue, onChange, onBlur, onAfterBlur, convertedPercentBase} = props;

    const [inputValue, setInputValue] = useState<number | string>(value);
    const [isValueChanging, setIsValueChanging] = useState<boolean>(false);
    const [popupState, setPopupState] = useState<IPopup>(popupInitialState);

    const actualMin = !!convertedPercentBase ? (min * convertedPercentBase) / 100 : min;
    const actualMax = !!convertedPercentBase ? (max * convertedPercentBase) / 100 : max;

    useEffect(() => {
        const newValue = typeof inputValue === "string" ? parseInt(inputValue.replace(/\s+/g, "")) : inputValue;

        isValueChanging && newValue !== value && !Number.isNaN(newValue) && updateValue(valueType, newValue);
    }, [inputValue]);

    useEffect(() => {
        if (Number.isInteger(value)) {
            setInputValue(formatBigNumbers(value));
            return;
        }

        setInputValue(formatBigNumbers(Math.round(value)));
    }, [value]);

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsValueChanging(true);

        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));

        if (Number.isNaN(newValue)) {
            setPopupState({show: true, isMin: true});
            setInputValue("");
            return;
        }

        if (newValue && newValue < actualMin) {
            setPopupState({show: true, isMin: true});
        } else if (newValue && newValue > actualMax) {
            setPopupState({show: true, isMin: false});
        } else if (popupState.show) {
            setPopupState(popupInitialState);
        }

        if (onChange) {
            onChange(event);
            return;
        }

        setInputValue(newValue);
    };

    const onInputBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsValueChanging(false);

        if (popupState) {
            setPopupState(popupInitialState);
        }

        if (onBlur) {
            onBlur(event);
            return;
        }

        if (event.target.value === "") {
            setInputValue(formatBigNumbers(Math.floor(value)));

            updateValue(valueType, actualMin);
            return;
        }

        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));

        if (Number.isNaN(newValue)) {
            onInvalidValue();
            return;
        }

        if (newValue < actualMin) {
            updateValue(valueType, actualMin);
            onAfterBlur && onAfterBlur(newValue, actualMin, actualMax);
            return;
        }

        if (newValue > actualMax) {
            updateValue(valueType, actualMax);
            onAfterBlur && onAfterBlur(newValue, actualMin, actualMax);
            return;
        }

        onAfterBlur && onAfterBlur(newValue, actualMin, actualMax);
    };

    const getUnitLabel = () => {
        switch (valueType) {
            case CalculatorValueType.CONTRIBUTION:
                return !!convertedPercentBase ? "zł" : "%";
            case CalculatorValueType.AGE:
                return " lat";
            default:
                return "zł";
        }
    };

    return (
        <div css={[position("relative"), wrapperStyle]}>
            <Popover
                isActive={popupState.show}
                type="warning"
                popoverPlace="top"
                body={
                    <div css={[flexAbsoluteCenter, flexDirection("column")]}>
                        <Text variant="info_txt_1" css={mb(0.5)}>{`${popupState.isMin ? "Minimalna" : "Maksymalna"} wartość:`}</Text>
                        <Text variant="info_txt_1">{`${popupState.isMin ? formatBigNumbers(actualMin) : formatBigNumbers(actualMax)}${getUnitLabel()}`}</Text>
                    </div>
                }
                toggleFocusHandler
                toggleOnClickOutside
                wrapperStyle={popupWrapperStyle}
                bodyStyle={popoverBodyStyle}
            >
                <Input
                    value={inputValue}
                    onChange={onInputChange}
                    onBlur={onInputBlur}
                    rightElement={
                        <Text css={m(0)} variant="body_copy_2">
                            {label}
                        </Text>
                    }
                    elementCustomStyle={{margin: 0}}
                    inputtextalign="right"
                    testid={CREDIT_PAGES_IDS.COMMON.FORM_INPUT}
                />
            </Popover>
        </div>
    );
};

const popupWrapperStyle = css`
    transform: translateY(15px);
`;

const popoverBodyStyle = css`
    ${minHeight(calculateRemSize(8))};
`;
import React, {useEffect, useState} from "react";
import {css, SerializedStyles} from "@emotion/react";

import {calculateRemSize, flexAbsoluteCenter, flexDirection, m, mb, minHeight, position} from "@pg-design/helpers-css";
import {Input} from "@pg-design/inputs-module";
import {Popover} from "@pg-design/notifications";
import {Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

import {CalculatorValueType} from "../../types/CalculatorValueType";
import {formatBigNumbers} from "../../utils/format_big_numbers";

interface IPopup {
    show: boolean;
    isMin: boolean;
}

const popupInitialState: IPopup = {
    show: false,
    isMin: true
};

interface IProps {
    value: number;
    label: string;
    min: number;
    max: number;
    wrapperStyle?: SerializedStyles | SerializedStyles[];
    valueType: CalculatorValueType;
    updateValue: (type: CalculatorValueType, value: number) => void;
    onInvalidValue: (value?: number) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onAfterBlur?: (value: number, min: number, max: number) => void;
    convertedPercentBase?: number;
    dataTestId?: string;
}

export const CalculatorBaseInput = (props: IProps) => {
    const {value, min, max, label, valueType, updateValue, wrapperStyle, onInvalidValue, onChange, onBlur, onAfterBlur, convertedPercentBase} = props;

    const [inputValue, setInputValue] = useState<number | string>(value);
    const [isValueChanging, setIsValueChanging] = useState<boolean>(false);
    const [popupState, setPopupState] = useState<IPopup>(popupInitialState);

    const actualMin = !!convertedPercentBase ? (min * convertedPercentBase) / 100 : min;
    const actualMax = !!convertedPercentBase ? (max * convertedPercentBase) / 100 : max;

    useEffect(() => {
        const newValue = typeof inputValue === "string" ? parseInt(inputValue.replace(/\s+/g, "")) : inputValue;

        isValueChanging && newValue !== value && !Number.isNaN(newValue) && updateValue(valueType, newValue);
    }, [inputValue]);

    useEffect(() => {
        if (Number.isInteger(value)) {
            setInputValue(formatBigNumbers(value));
            return;
        }

        setInputValue(formatBigNumbers(Math.round(value)));
    }, [value]);

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsValueChanging(true);

        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));

        if (Number.isNaN(newValue)) {
            setPopupState({show: true, isMin: true});
            setInputValue("");
            return;
        }

        if (newValue && newValue < actualMin) {
            setPopupState({show: true, isMin: true});
        } else if (newValue && newValue > actualMax) {
            setPopupState({show: true, isMin: false});
        } else if (popupState.show) {
            setPopupState(popupInitialState);
        }

        if (onChange) {
            onChange(event);
            return;
        }

        setInputValue(newValue);
    };

    const onInputBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsValueChanging(false);

        if (popupState) {
            setPopupState(popupInitialState);
        }

        if (onBlur) {
            onBlur(event);
            return;
        }

        if (event.target.value === "") {
            setInputValue(formatBigNumbers(Math.floor(value)));

            updateValue(valueType, actualMin);
            return;
        }

        const newValue = parseInt(event.target.value.replace(/\s+/g, ""));

        if (Number.isNaN(newValue)) {
            onInvalidValue();
            return;
        }

        if (newValue < actualMin) {
            updateValue(valueType, actualMin);
            onAfterBlur && onAfterBlur(newValue, actualMin, actualMax);
            return;
        }

        if (newValue > actualMax) {
            updateValue(valueType, actualMax);
            onAfterBlur && onAfterBlur(newValue, actualMin, actualMax);
            return;
        }

        onAfterBlur && onAfterBlur(newValue, actualMin, actualMax);
    };

    const getUnitLabel = () => {
        switch (valueType) {
            case CalculatorValueType.CONTRIBUTION:
                return !!convertedPercentBase ? "zł" : "%";
            case CalculatorValueType.AGE:
                return " lat";
            default:
                return "zł";
        }
    };

    return (
        <div css={[position("relative"), wrapperStyle]}>
            <Popover
                isActive={popupState.show}
                type="warning"
                popoverPlace="top"
                body={
                    <div css={[flexAbsoluteCenter, flexDirection("column")]}>
                        <Text variant="info_txt_1" css={mb(0.5)}>{`${popupState.isMin ? "Minimalna" : "Maksymalna"} wartość:`}</Text>
                        <Text variant="info_txt_1">{`${popupState.isMin ? formatBigNumbers(actualMin) : formatBigNumbers(actualMax)}${getUnitLabel()}`}</Text>
                    </div>
                }
                toggleFocusHandler
                toggleOnClickOutside
                wrapperStyle={popupWrapperStyle}
                bodyStyle={popoverBodyStyle}
            >
                <Input
                    value={inputValue}
                    onChange={onInputChange}
                    onBlur={onInputBlur}
                    rightElement={
                        <Text css={m(0)} variant="body_copy_2">
                            {label}
                        </Text>
                    }
                    elementCustomStyle={{margin: 0}}
                    inputtextalign="right"
                    testid={CREDIT_PAGES_IDS.COMMON.FORM_INPUT}
                />
            </Popover>
        </div>
    );
};

const popupWrapperStyle = css`
    transform: translateY(15px);
`;

const popoverBodyStyle = css`
    ${minHeight(calculateRemSize(8))};
`;
